import { LotteryTemplateSchema, RetailUnitSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetLotteryTemplatesParams = Static<typeof GetLotteryTemplateParamsSchema>;
export const GetLotteryTemplateParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetLotteryTemplateParamsSchema' }
);

export type GetLotteryTemplateResponse = Static<typeof GetLotteryTemplateResponseSchema>;
export const GetLotteryTemplateResponseSchema = Type.Object(
  {
    lotteryTemplates: Type.Array(LotteryTemplateSchema),
  },
  { additionalProperties: false, $id: 'GetLotteryTemplateResponseSchema' }
);
